import { render } from "./BalBlankSlate.vue?vue&type=template&id=ea44f706"
import script from "./BalBlankSlate.vue?vue&type=script&lang=ts"
export * from "./BalBlankSlate.vue?vue&type=script&lang=ts"

import "./BalBlankSlate.vue?vue&type=style&index=0&id=ea44f706&lang=css"
script.render = render

export default script